// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__g-9qh","upload":"Small_upload__153ci","imageWrap":"Small_imageWrap__3NCpS","removeBtn":"Small_removeBtn__1q9Kk"};